<script setup>
definePageMeta({
    layout: 'public-alt',
    middleware: 'public-site'
});
</script>

<template>
    <NuxtPage />
</template>